import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AtxModalComponent } from './atx-modal.component';

@Component({
    template: `<div class="modal-header">
    <h4 class="modal-title"
        *ngIf="title">
        {{ title }}
    </h4>
    <button type="button"
            class="close"
            aria-label="Close"
            (click)="dismissModal()">
    </button>
</div>
<div class="modal-body mt-0">
    <div class="container-fluid p-0">
        <div #container></div>
    </div>
</div>
<div class="modal-footer"
     *ngIf="hasFooter">
    <button type="button"
            class="btn btn-outline-dark"
            (click)="closeModal()">
        {{ 'common.label.close' }}
    </button>
    <button type="button"
            class="btn btn-outline-dark"
            (click)="acceptModal()">
        {{ 'common.label.submit' }}
    </button>
</div>
`,
    styles: [],
})

export class AtxModalSimpleComponent extends AtxModalComponent implements OnInit {
    @Input() content;

    @Output() fireSubmit: EventEmitter<any> = new EventEmitter();

    constructor(
        private activeModal: NgbActiveModal,
        private componentFactoryResolver: ComponentFactoryResolver,
    ) {
        super(activeModal);
    }

    ngOnInit() {
        super.ngOnInit();
        const component = this.componentFactoryResolver.resolveComponentFactory(this.content);

        this.options.activeModal = this.activeModal;
        this.componentRef = this.container.createComponent(component);

        this.setOptionsInModal();
    }

    public acceptModal() {
        super.acceptModal();
    }

    private setOptionsInModal() {
        Object.keys(this.options).forEach((key) => {
            this.componentRef.instance[ key ] = this.options[ key ];
        });
    }
}
